import { call, put, takeEvery } from "redux-saga/effects";
import fetchService from "../../../lib/fetchService";
import { FETCH_FILES_REQUEST, fetchFileError, fetchFileSuccess } from "./action";
import config from "../../../config";

const requestSaga = function*({ payload, meta }) {
  const { fileUuid, fileToken } = payload;

  const url = `${config.urls.STORAGE_SERVICE}/files/${fileUuid}`;
  const data = { token: fileToken };

  try {
    const response = yield call(fetchService.get, url, data);
    if (response.ok) {
      const responseData = yield call(() => response.json());
      const defaultAction = fetchFileSuccess(fileUuid, responseData);
      if (!meta || !meta.onSuccess) {
        yield put(defaultAction);
      } else {
        yield put({
          ...defaultAction,
          meta: meta.onSuccess,
        });
      }
    } else {
      const statusCode = response.status;
      const defaultAction = fetchFileError(fileUuid, new Error(`Request failed with error ${statusCode}!`));
      if (!meta || !meta.onFailure) {
        yield put(defaultAction);
      } else {
        yield put({
          ...defaultAction,
          meta: meta.onFailure,
        });
      }
    }
  } catch (e) {
    const defaultAction = fetchFileError(fileUuid, e);
    if (!meta || !meta.onFailure) {
      yield put(defaultAction);
    } else {
      yield put({
        ...defaultAction,
        meta: meta.onFailure,
      });
    }
  }
};

export default function*() {
  yield takeEvery(FETCH_FILES_REQUEST, requestSaga);
}
